import { useQuery } from "@tanstack/react-query";
import { fetchApiGet } from "../../../../utils";
import { TtOrderMetadata } from "../types";

export type ReasonCode =
  | "missing_customer"
  | "missing_order_type"
  | "missing_otc_type"
  | "missing_crop_year";

export interface NeedsAttentionRow {
  guid_order_id: string;
  exchange_event_time: string;
  trading_account_name: string | null;
  user_name: string | null;
  instrument_name: string | null;
  buy_sell_type: string | null;
  order_quantity: string | null;
  order_uom_quantity: string | null;
  working_quantity: string | null;
  remaining_quantity: string | null;
  filled_quantity: string | null;
  limit_price: string | null;
  text_a: string | null;
  text_b: string | null;
  text_c: string | null;
  text_tt: string | null;
  metadata: TtOrderMetadata | null;
  needs_attention_reasons: ReasonCode[];
}

export interface NeedsAttentionResponse {
  snapshot_id: string | null;
  snapshot_taken_at: string | null;
  rows: NeedsAttentionRow[];
}

export const NEEDS_ATTENTION_QUERY_KEY = ["risk", "brokerage", "tt", "v2", "needs-attention"] as const;

export function useListNeedsAttention(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: NEEDS_ATTENTION_QUERY_KEY,
    queryFn: () => fetchApiGet<NeedsAttentionResponse>("/brokerage/tt/v2/needs-attention"),
    enabled: options?.enabled ?? true,
  });
}
